"use client";

import React from "react";

import Image from "next/image";
import Chip from "@/components/global/ui/Chip";
import DecorationSquares from "@/components/global/ui/DecorationSquares";
import DecorationLine from "@/components/global/ui/DecorationLine";

import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {CTACornerButton} from "@/shadcn/ui/corner-button";

import {PageCommunitySchema} from "@/sanity/pages/PageCommunityTemplate";

export default function HeroSection({
  data,
  className
}: {
  data: PageCommunitySchema;
  className?: string;
}) {

  return (
    <section className={cn(
      "relative overflow-clip",
      className
    )}>
      <DecorationSquares
        className="top-[2px]"
      />

      <div className="relative py-[6rem] lg:pb-[7rem] lg:pt-[8rem]">
        <DecorationLine
          className="top-0 hidden lg:block"
          orientation="vertical"
          position="left"
        />
        <DecorationLine
          className="top-0 hidden lg:block"
          orientation="vertical"
          position="right"
        />
        <DecorationLine
          className="bottom-0"
          orientation="horizontal"
        />

        <div className="container relative flex flex-col items-center">
          <Chip
            className="prose-img:!w-[3rem]"
            image={data?.heroChip?.icon}
            text={data?.heroChip?.text}
          />

          {data?.heroTitle && (
            <div className="richtext prose-p:w-[min(92.5rem,100%)] prose-headings:w-[min(112.5rem,100%)] [&_.inline-icon]:!m-0 [&_.inline-icon]:!w-[5rem] sm:[&_.inline-icon]:!w-[7rem] lg:[&_.inline-icon]:!w-[9rem] [&_.inline-icon]:-translate-y-[.125rem]">
              <PortableText
                value={data.heroTitle}
                components={richTextComponent}
              />
            </div>
          )}

          {data?.heroCTA && (
            <CTACornerButton
              className="mt-[2rem]"
              data={data.heroCTA}
            />
          )}
        </div>
      </div>

      {data?.heroImages && (
        <div
          className="py-[2rem] flex justify-start pl-[1rem] gap-[1rem] [--item-width:30.625rem] lg:[--item-width:48rem]"
          style={{
            width: `calc(${data.heroImages.length * 2} * var(--item-width) + ${data.heroImages.length * 2}rem)`,
            animation: `scrollLeft ${data?.heroImages.length * 3}s linear infinite`
          }}
        >
          {[...data.heroImages, ...data.heroImages].map((item, i) => (
            <div
              key={i}
              className="aspect-[384/480] flex-shrink-0 w-[var(--item-width)]"
            >
              <Image
                className="!w-full !h-full object-cover"
                src={item.image}
                alt=""
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
